/**
 * AI Fire API
 * API to access AI Fire sensor data
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import ValidationError from './ValidationError';

/**
 * The UnprocessableEntityResponse model module.
 * @module model/UnprocessableEntityResponse
 * @version 1.1.0
 */
class UnprocessableEntityResponse {
    /**
     * Constructs a new <code>UnprocessableEntityResponse</code>.
     * General unprocessable entity response
     * @alias module:model/UnprocessableEntityResponse
     * @param message {String} 
     * @param errors {Array.<module:model/ValidationError>} 
     */
    constructor(message, errors) { 
        
        UnprocessableEntityResponse.initialize(this, message, errors);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, message, errors) { 
        obj['message'] = message;
        obj['errors'] = errors;
    }

    /**
     * Constructs a <code>UnprocessableEntityResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/UnprocessableEntityResponse} obj Optional instance to populate.
     * @return {module:model/UnprocessableEntityResponse} The populated <code>UnprocessableEntityResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new UnprocessableEntityResponse();

            if (data.hasOwnProperty('message')) {
                obj['message'] = ApiClient.convertToType(data['message'], 'String');
            }
            if (data.hasOwnProperty('errors')) {
                obj['errors'] = ApiClient.convertToType(data['errors'], [ValidationError]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>UnprocessableEntityResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>UnprocessableEntityResponse</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of UnprocessableEntityResponse.RequiredProperties) {
            if (!data.hasOwnProperty(property)) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['message'] && !(typeof data['message'] === 'string' || data['message'] instanceof String)) {
            throw new Error("Expected the field `message` to be a primitive type in the JSON string but got " + data['message']);
        }
        if (data['errors']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['errors'])) {
                throw new Error("Expected the field `errors` to be an array in the JSON data but got " + data['errors']);
            }
            // validate the optional field `errors` (array)
            for (const item of data['errors']) {
                ValidationError.validateJSON(item);
            };
        }

        return true;
    }


}

UnprocessableEntityResponse.RequiredProperties = ["message", "errors"];

/**
 * @member {String} message
 */
UnprocessableEntityResponse.prototype['message'] = undefined;

/**
 * @member {Array.<module:model/ValidationError>} errors
 */
UnprocessableEntityResponse.prototype['errors'] = undefined;






export default UnprocessableEntityResponse;

